import React, { Component } from "react";
import OTG_API from "/lib/otg-api";
import toClassName from "/functions/to-class-name";
import getImageSize from "/functions/get-image-size";

class RetailersGrid extends Component {
  getRetailers = () => {
    return this.props.retailers.map((r) => (
      <Retailer key={r.id} retailer={r} />
    ));
  };

  render() {
    return (
      <ul className={"vendors-grid vendors-grid-compact grid-cards-get-mini"}>
        {this.getRetailers()}
      </ul>
    );
  }
}

class Retailer extends Component {
  render() {
    const { retailer } = this.props;
    const { vendor } = retailer;

    // Safeguard against incomplete vendor data
    if (!vendor || !vendor.permalink) {
      return null; // Optionally render a loading state
    }

    return (
      <li className="grid-item-card">
        <span className="vendor">
          <article>
            <div
              className="logo-img"
              style={{
                backgroundImage: `url(${getImageSize("--small", vendor.logoUrl)})`,
              }}
            />
            <div className="content-wrap">
              <header>
                <a className="card-link-expanded" href={vendor.permalink}>
                  <h3>{vendor.name}</h3>
                </a>
              </header>
            </div>
          </article>
        </span>
      </li>
    );
  }
}

export default class extends Component {
  state = {
    retailers: [],
    loadingComplete: false,
  };

  getRetailers = async () => {
    if (this.props.retailers.length) {
      const promises = this.props.retailers
        .filter((retailer) => retailer.vendor)
        .map((retailer) => {
          const vendorId = retailer.vendor.id;
  
          // Fetch Vendor and ensure full data (including permalink)
          return OTG_API.getVendor(vendorId)
            .then((vendor) => {
              if (vendor.fetchDetails) {
                return vendor.fetchDetails().then(() => {
                  retailer.vendor = vendor; // Assign the populated vendor back
                  return vendor;
                });
              }
              return vendor;
            })
            .catch((err) => {
              console.error(`Error fetching vendor ${vendorId}:`, err);
            });
        });
  
      try {
        await Promise.all(promises); // Wait for all vendors to be fetched
        this.setRetailers(this.props.retailers); // Update state with populated retailers
      } finally {
        this.setLoadingComplete(); // Mark loading as complete
      }
    } else {
      this.setRetailers(this.props.retailers);
      this.setLoadingComplete();
    }
  };

  setLoadingComplete = () => {
    this.setState({ loadingComplete: true });
  };

  setRetailers = (retailers) => {
    this.setState({ retailers });
  };

  theClasses = () => {
    return toClassName([
      "vendors-index",
      this.state.loadingComplete ? "loading-complete" : "loading",
    ]);
  };

  componentDidUpdate(prevProps) {
    if (
      this.props.event &&
      prevProps.event &&
      this.props.event.id !== prevProps.event.id
    ) {
      this.getRetailers(); // Fetch retailers when event changes
    }
  }

  componentDidMount() {
    this.getRetailers(); // Initial fetch on component mount
  }

  render() {
    return (
      <div className={this.theClasses()}>
        <RetailersGrid
          retailers={this.state.retailers}
          loadingComplete={this.state.loadingComplete}
        />
      </div>
    );
  }
}